import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { LocalStorageService } from 'api';

const localStorageService = new LocalStorageService();

const payments = 'payments';
const pay = 'pay';

export const externalAPI = createApi({
	reducerPath: 'externalAPI',

	baseQuery: fetchBaseQuery({
		baseUrl: '/',
		prepareHeaders: headers => {
			const token = localStorageService.getAccessToken();
			if (token) {
				headers.set('authorization', `Bearer ${token}`);
			}

			return headers;
		}
	}),

	endpoints: builder => ({
		renewSubscriptionWithNewCard: builder.mutation({
			query: data => ({
				url: `${payments}/${pay}`,
				body: data,
				method: 'POST'
			})
		})
	})
});

export const { useRenewSubscriptionWithNewCardMutation } = externalAPI;
